import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Folder } from '../models/folder.model';
import {
  catchError, map, Observable,
  throwError
} from 'rxjs';

import { BaseService } from './_base.service';

@Injectable()
export class FoldersService extends BaseService {

  create(value: { folder: Partial<Folder> }): Observable<Folder> {
    return this.http.post<Folder>(`${this.apiURL}/folders`, value, this.getOptions())
      .pipe(
        catchError((e) => {
          console.error(e);
          return throwError(() => e);
        }),
        map((response: HttpResponse<Folder>) => response.body),
      );
  }

  close(id: number): Observable<Folder> {
    return this.http.post<Folder>(`${this.apiURL}/folders/${id}/close`, {}, this.getOptions())
      .pipe(
        catchError((e) => {
          console.error(e);
          return throwError(() => e);
        }),
        map((response: HttpResponse<Folder>) => response.body),
      );
  }

  get(id: number): Observable<Folder> {
    return this.http.get<Folder>(`${this.apiURL}/folders/${id}`, this.getOptions())
      .pipe(
        map((response: HttpResponse<Folder>) => response.body),
        catchError((e) => {
          console.error(e);
          return throwError(() => e);
        }),
      );
  }
}
